var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"widget-item"},[_c('subscribe',{attrs:{"show_title":false,"show_description":false,"compact":true}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }